import * as yup from "yup";

export const checkoutFormSchema = yup.object().shape({
  actionsTaken: yup.string().default(""),
  nextSteps: yup.string().default(""),
  resolutionDetails: yup.string().default(""),
  roomStatus: yup.string().required("Room status is required"),
  statusReason: yup.string().required("Status reason is required"),
  serviceComplete: yup.boolean().default(false),
  pmVisit: yup.boolean().default(false),
});
